/** @flow */

import {
  GetEmployeeDocumentsSuccess,
  GetEmployeeDocumentsError,
  ToggleRemoveEmployeeDocumentModal,
  RemoveEmployeeDocumentError,
  ToggleAddEmployeeDocumentModal,
  AddEmployeeDocumentError,
  GetEmployeeEventHistory,
  GetEmployeeEventHistorySuccess,
  GetEmployeeEventHistoryError,
  GetManualReferralEnabledSuccess,
  GetReferralProcessesSuccess,
  ToggleManualReferralModal,
  ToggleEventHistoryItemModal,
  ToggleAbsenceReviewModal,
  ToggleReferralDecisionModal,
  GetManualReferralTaskDataSuccess,
  ToggleManualReferralTaskDataModal,
  GetEmployeeSpecificDocumentsSuccess,
  GetEmployeeDocuments,
  DownloadEmployeeDocument,
  DownloadEmployeeDocumentSuccess,
  DownloadEmployeeDocumentError,
  ResetEmployeeEventHistory,
  AddEmployeeAppeal,
  AddEmployeeAppealSuccess,
  AddEmployeeAppealError,
  UpdateEmployeeAppeal,
  UpdateEmployeeAppealSuccess,
  UpdateEmployeeAppealError,
  ResolveEmployeeAppeal,
  ResolveEmployeeAppealSuccess,
  ResolveEmployeeAppealError,
} from "@modules/shared/constants/actions";
import * as reducers from "./reducers";
import type { EmployeeEventsState } from "./types";
import initialState from "./state";
import { cloneObject } from "@utils/object";

export default (state: EmployeeEventsState = initialState, action: Object): Object => {
  const act = {
    [GetEmployeeDocuments]: reducers.setLoading,
    [GetEmployeeDocumentsSuccess]: reducers.onGetEmployeeDocumentsSuccess,
    [GetEmployeeSpecificDocumentsSuccess]: reducers.onGetEmployeeSpecificDocumentsSuccess,
    [GetEmployeeDocumentsError]: reducers.onGetEmployeeDocumentsError,
    [ToggleRemoveEmployeeDocumentModal]: reducers.onToggleRemoveEmployeeDocumentModal,
    [RemoveEmployeeDocumentError]: reducers.onRemoveEmployeeDocumentError,
    [ToggleAddEmployeeDocumentModal]: reducers.onToggleAddEmployeeDocumentModal,
    [AddEmployeeDocumentError]: reducers.onAddEmployeeDocumentError,
    [GetEmployeeEventHistory]: reducers.onGetEmployeeEventHistory,
    [GetEmployeeEventHistorySuccess]: reducers.onGetEmployeeEventHistorySuccess,
    [GetManualReferralEnabledSuccess]: reducers.onGetManualReferralEnabledSuccess,
    [GetEmployeeEventHistoryError]: reducers.onGetEmployeeEventHistoryError,
    [ResetEmployeeEventHistory]: reducers.onResetEmployeeEventHistory,
    [GetReferralProcessesSuccess]: reducers.onGetReferralProcessesSuccess,
    [ToggleManualReferralModal]: reducers.onToggleManualReferralModal,
    [ToggleEventHistoryItemModal]: reducers.onToggleEventHistoryItemModal,
    [ToggleAbsenceReviewModal]: reducers.onToggleAbsenceReviewModal,
    [ToggleReferralDecisionModal]: reducers.onToggleReferralDecisionModal,
    [GetManualReferralTaskDataSuccess]: reducers.onGetManualReferralTaskDataSuccess,
    [ToggleManualReferralTaskDataModal]: reducers.onToggleManualReferralTaskDataModal,
    [DownloadEmployeeDocument]: reducers.setLoading,
    [DownloadEmployeeDocumentSuccess]: reducers.setLoaded,
    [DownloadEmployeeDocumentError]: reducers.setLoaded,
    [AddEmployeeAppeal]: reducers.setLoading,
    [AddEmployeeAppealSuccess]: reducers.setLoaded,
    [AddEmployeeAppealError]: reducers.setLoaded,
    [UpdateEmployeeAppeal]: reducers.setLoading,
    [UpdateEmployeeAppealSuccess]: reducers.setLoaded,
    [UpdateEmployeeAppealError]: reducers.setLoaded,
    [ResolveEmployeeAppeal]: reducers.setLoading,
    [ResolveEmployeeAppealSuccess]: reducers.setLoaded,
    [ResolveEmployeeAppealError]: reducers.setLoaded,
  };

  if (action && action.type && act && act[action.type]) {
    return act[action.type](cloneObject(state))(action);
  }
  return state;
};
